"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[755],{

/***/ 30755:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14416);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18132);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);





var HomeOffersList = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(6741), __webpack_require__.e(5061), __webpack_require__.e(7651), __webpack_require__.e(7855), __webpack_require__.e(7120), __webpack_require__.e(2668), __webpack_require__.e(7495)]).then(__webpack_require__.bind(__webpack_require__, 52711));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(52711)];
    }
  }
});

var HomeNltOffersContainer = function HomeNltOffersContainer(_ref) {
  var title = _ref.title,
      href = _ref.href,
      action = _ref.action,
      alt = _ref.alt,
      numPerView = _ref.numPerView,
      w = _ref.w,
      bgColor = _ref.bgColor;
  var offers = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(function (state) {
    return state.nlt.offers;
  });
  var defaultHref = '/noleggio-a-lungo-termine';

  var _useTranslation = (0,react_i18next__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$)(),
      t = _useTranslation.t;

  var offersList = offers.filter(function (offer) {
    return offer.code !== 'auto-promo';
  });
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(HomeOffersList, {
    title: title,
    action: action,
    href: href || defaultHref,
    alt: alt || action,
    offers: offersList,
    numPerView: numPerView,
    w: w,
    bgColor: bgColor
  });
};

/* harmony default export */ __webpack_exports__["default"] = (HomeNltOffersContainer);

/***/ })

}]);